import * as t from "./actionTypes";

// eslint-disable-next-line
export const cartReducer = (state = { cartItems: [] }, action) => {
  switch (action.type) {
    case t.ADD_CART_ITEM:
      return {
        ...state,
        cartItems: [...state.cartItems, action.payload]
      };
    case t.DELETE_CART_ITEM:
      return {
        ...state,
        cartItems: state.cartItems.filter(
          item => item.articleID !== action.payload.articleID
        )
      };
    case t.FLUSH_CART:
      return {
        ...state,
        cartItems: []
      };
    default:
      return state;
  }
};

export const contactReducer = (
  state = {
    contactStatus: {
      indication: null,
      error: {
        status: null,
        message: null
      }
    }
  },
  action
) => {
  switch (action.type) {
    case t.CONTACT_REQUEST: {
      return {
        ...state,
        contactStatus: {
          indication: "loading",
          error: {
            status: null,
            message: null
          }
        }
      };
    }
    case t.CONTACT_REQUEST_SUCCESS: {
      return {
        ...state,
        contactStatus: {
          indication: "loaded",
          error: {
            status: null,
            message: null
          }
        }
      };
    }

    case t.CONTACT_REQUEST_FAILURE: {
      const { response } = action.payload;
      return {
        ...state,
        contactStatus: {
          indication: "error",
          error: {
            status: response.status,
            message: response.data.uiMessage
          }
        }
      };
    }

    default:
      return state;
  }
};

export const uiReducer = (
  state = {
    showUVP: true,
    showPrice: true
  },
  action
) => {
  switch (action.type) {
    case t.TOGGLE_SHOW_PRICE:
      return {
        ...state,
        showPrice: !state.showPrice
      };
    case t.TOGGLE_SHOW_UVP:
      return {
        ...state,
        showUVP: !state.showUVP
      };
    default:
      return state;
  }
};

export const checkoutReducer = (
  state = {
    checkoutStatus: {
      indication: null,
      error: {
        status: null,
        message: null
      }
    }
  },
  action
) => {
  switch (action.type) {
    case t.FLUSH_CART:
      return {
        ...state,
        checkoutStatus: {
          indication: null,
          error: {
            status: null,
            message: null
          }
        }
      };
    case t.CHECKOUT_REQUEST:
      return {
        ...state,
        checkoutStatus: {
          indication: "loading",
          error: {
            status: null,
            message: null
          }
        }
      };
    case t.CHECKOUT_REQUEST_SUCCESS:
      return {
        ...state,
        checkoutStatus: {
          indication: "loaded",
          error: {
            status: null,
            message: null
          }
        }
      };
    // eslint-disable-next-line
    case t.CHECKOUT_REQUEST_FAILURE:
      const { response } = action.payload;
      return {
        ...state,
        checkoutStatus: {
          indication: "error",
          error: {
            status: response.status,
            message: response.data.uiMessage
          }
        }
      };
    default:
      return state;
  }
};

export const authReducer = (
  state = {
    authStatus: {
      indication: null,
      error: {
        status: null,
        message: null
      }
    },
    currentUser: null
  },
  action
) => {
  switch (action.type) {
    case t.LOGIN_REQUEST:
      return {
        ...state,
        authStatus: {
          indication: "loading",
          error: {
            status: null,
            message: null
          }
        }
      };
    case t.LOGIN_REQUEST_SUCCESS:
      return {
        ...state,
        authStatus: {
          indication: "loaded",
          error: {
            status: null,
            message: null
          }
        }
      };
    // eslint-disable-next-line
    case t.LOGIN_REQUEST_FAILURE:
      const { response } = action.payload;
      return {
        ...state,
        authStatus: {
          indication: "error",
          error: {
            status: response.status,
            message: response.data.uiMessage
          }
        }
      };
    case t.SET_CURRENT_USER:
      return {
        ...state,
        currentUser: action.payload
      };
    case t.LOGOUT_USER:
      return {
        ...state,
        authStatus: {
          indication: null,
          error: {
            status: null,
            message: null
          }
        },
        currentUser: null
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers.js